import React, { Component } from 'react';
import classNames from 'classnames'

import Button from '../pageContent/Button'

import Mouse from '../navigation/Mouse'
// import Arrow from '../navigation/Arrow'

import './Hero.css'



class Hero extends Component {

    constructor(props) {

        super(props)

        this.state = {
            isReady: false,
            delay: 0.1
            
        }

    }

    componentDidMount() {

        setTimeout(() => {

            this.onReady()

        }, 0)

    }

    onReady() {
        this.setState({
            isReady: true
        })
    }


    render() {

        const { isReady } = this.state
        const { color, title, subtitle, viewport, to, isCentered, media, background, showScroll } = this.props

        const words = title.split(' ')

        const heroStyle = {
            height: viewport.height
        }

        const fadeStyle = {
            opacity: isReady ? 1 : 0,
            transition: 'all 0.5s'
        }

        const imgStyle = {
            opacity: isReady ? 1 : 0,
            transition: 'all 0.5s',
            transform: isReady ? 'translateY(0)' : 'translateY(100px)',
        }

        const heroClass = classNames({
            'hero': true,
            'text-center': isCentered
        });

        
        const gridClass = classNames({
            'unit': true,
            theme: true,
            'half': true
        });

        const backgroundCover = React.cloneElement(background, {
            isReady,
            color,
            size: viewport
        })

        return (
            <div className={heroClass} style={heroStyle}>

                {viewport.width > 0 &&
                    backgroundCover
                }

                <div className="cell">

                    <div className="grid xs-text-center">

                        {!media &&
                            <div className="unit one-quarter"></div>
                        }

                        <div className={gridClass}>

                            <div className="hr-container">
                                {/* <hr style={fadeStyle} className='left ' /> */}
                                <hr style={fadeStyle} />
                            </div>
                    
                            { /* <h4 style={fadeStyle}>{subtitle}</h4> */}

                            <h1 className="mb5">
                                {words.map((word, index) => {

                                    const wordStlye = {
                                        opacity: isReady ? 1 : 0,
                                        transform: isReady ? 'translateY(0)' : 'translateY(20px)',
                                        transitionDelay: isReady ? `${this.state.delay * index}s` : 0
                                    }

                                    return <span key={index} className="word" style={wordStlye}>
                                        {word}
                                    </span>

                                })}
                            </h1>

                            <p style={fadeStyle} className="copy">{subtitle}</p>

                            {to &&
                                <p style={fadeStyle}>
                                    { to.includes('github.com') ? 
                                    <Button to={to} className="poke" external={true}>Source code</Button>
                                     : 
                                    
                                    <Button to={to} className="poke" external={true}>Project site</Button>
                                    
                                    }
                                </p>
                            }

                            {/*<hr/>*/}

                        </div>


                        {media &&
                        
                            <div className="half unit">
                                <div style={imgStyle} >
                                    {media}
                                </div>

                            </div>
                        
                        }


                    </div>


                </div>

                {showScroll && <Mouse />}
                {/*<Arrow />*/}

            </div>
        );
    }
}

export default Hero;